//モジュールのインポート（node-moduleにあるファイルは、ファイル名のみで読み込める）
import 'jquery.easing/jquery.easing';  //jquery.easing読み込み
import 'jquery-color/jquery.color';   //jquery-color/jquery.color読み込み
import script_loadingSplash from './modules/script_loadingSplash';    //ローディング（スプラッシュ）読み込み
import script_burgerMenu from './modules/script_burgerMenu';          //ハンバーガーメニュー読み込み
import script_telNonPc from './modules/script_telNonPc';              //PC電話発信なし読み込み
import script_heroAnimation from './modules/script_heroAnimation';    //トップページヒーローアニメーション読み込み
import script_tabAccordion from './modules/script_tabAccordion';      //タブアコーディオン読み込み
import 'textillate/jquery.textillate';                        //jquery.textillate読み込み
import 'textillate/assets/jquery.lettering';                  //jquery.lettering読み込み
import 'textillate/assets/animate.css';                       //animate.css読み込み
import script_textillate from './modules/script_textillate';  //script_textillate読み込み

//モジュール先にある関数実行
script_loadingSplash();   //ローディング（スプラッシュ）スクリプト実行
script_burgerMenu();      //ハンバーガーメニュースクリプト実行
script_telNonPc();        //PC電話発信なしスクリプト実行
script_heroAnimation();   //トップページヒーローアニメーションスクリプト実行
script_tabAccordion();    //タブアコーディオンスクリプト実行
script_textillate();      //テキストアニメーションスクリプト実行
